const HEXADECIMAL_REGEX = new RegExp(/^[0-9a-f]{32}$/);

/**
 * Check if `hex` is 32 character hexstring
 * These strings are commonly used across Vita apps as id strings
 * @param {unknown} hex possible hexstring
 * @returns {hex is string}
 */
export const isHexId = (hex: unknown): hex is string =>
	typeof hex === "string" && HEXADECIMAL_REGEX.test(hex);
